module.exports = __webpack_public_path__ + "static/media/sparkles.0292fdae.svg";